import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import BeforeAfterSection from './components/BeforeAfterSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseUs from './components/WhyChooseUs';
import PainPointSection from './components/PainPointSection';
import MidPageCTA from './components/MidPageCTA';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <BeforeAfterSection />
      <ServicesSection />
      <WhyChooseUs />
      <PainPointSection />
      <MidPageCTA />
      <ProcessSection />
      <TestimonialsSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
